import { Injectable } from '@angular/core';
import { RoutingPath } from 'mbs-ui-shared@constants';
import { ConfigurationService } from 'mbs-ui-shared@services/configuration.service';

const baseHelpUrl = 'https://help.mspbackups.com';
const manageComputers = '/remote-management/manage-computers';
const backupHistory = '/reporting/monitoring-history/backup-history';
const helpDictionaryRaw: Partial<Record<RoutingPath, string>> = {
  [RoutingPath.ApAdministrators]: '/organization/administrators/manage-administrators',
  [RoutingPath.ApAppsDomains]: '/gapps-office365/manage-domains',
  [RoutingPath.ApAppsGeneral]: '', // Not available yet
  [RoutingPath.ApAuditLog]: '/organization/audit-log',
  [RoutingPath.ApBackupComputers]: manageComputers,
  [RoutingPath.ApBackupHistory]: backupHistory,
  [RoutingPath.ApBackupHistoryLegacy]: backupHistory,
  [RoutingPath.ApBackupTemplates]: '/remote-management/remote-deploy/manage-configurations',
  [RoutingPath.ApBranding]: '/organization/settings/branding',
  [RoutingPath.ApCompanies]: '/organization/companies',
  [RoutingPath.ApComputers]: manageComputers,
  [RoutingPath.ApConnectWiseNew]: '/integrations/connectwise-manage/scenario',
  [RoutingPath.ApDashboard]: '', // Should I implement this link?
  [RoutingPath.ApEmailService]: '/organization/settings/email-service',
  [RoutingPath.ApGlobalAgentOptions]: '/organization/settings/global-agent-options',
  [RoutingPath.ApLicenses]: '/licenses/manage-licenses',
  [RoutingPath.ApNewBackupHistory]: backupHistory,
  [RoutingPath.ApNotifications]: '/organization/settings/notifications',
  [RoutingPath.ApPlanReportSettings]: '/reporting/plan-settings',
  [RoutingPath.ApRDStatistics]: '/remote-management/connect/using-managed-remote-desktop/view-statistics',
  [RoutingPath.ApRMMComputers]: manageComputers,
  [RoutingPath.ApRMMAlertsHistory]: '/remote-management/rmm-service/rmm-alert-history',
  [RoutingPath.ApRMMGroupTaskAction]: '/remote-management/rmm-service/management/group-actions-new',
  [RoutingPath.ApRestore2Cloud]: '/restore/restore2cloud/restore2cloud-intro',
  [RoutingPath.ApScheduledReports]: '/reporting/reports',
  [RoutingPath.ApSettings]: '/organization/settings/general-settings',
  [RoutingPath.ApSnmp]: '/remote-management/rmm-service/management/snmp',
  [RoutingPath.ApSSL]: '/security/bindings-certificates',
  [RoutingPath.ApStorages]: '/billing-storage/storage-accounts',
  [RoutingPath.ApStorageCapacityReport]: '/billing-storage/storage-usage',
  [RoutingPath.ApUsers]: '/organization/users/create-users',
  [RoutingPath.RMMNotifications]: '/remote-management/rmm-service/manage-alerts',
  [RoutingPath.RMMScriptLibrary]: '/remote-management/rmm-service/management/script-library'
};

export enum HelpLinkAspect {
  'postPayment' = 'postPayment'
}

const helpDictionary: Record<string, string> = {
  ...helpDictionaryRaw,
  [`${RoutingPath.ApLicenses}-${HelpLinkAspect.postPayment}`]: '/organization/licenses/modes/post-payment'
};

@Injectable({
  providedIn: 'root'
})
export class HelpService {
  constructor(private config: ConfigurationService) {}

  public getHelpLink(pageAddress: string): string {
    return (this.config.get('helpUrl') || baseHelpUrl) + (pageAddress || '');
  }

  public openHelpPage(path: string, aspect?: HelpLinkAspect): void {
    const link = aspect ? helpDictionary[`${path}-${aspect}`] : helpDictionary[path];

    this.openWindow(this.getHelpLink(link || ''), '_blank');
  }

  private openWindow(url: string, target?: string): void {
    window.open(url, target);
  }
}
